import { render, staticRenderFns } from "./SubStatusIcon.vue?vue&type=template&id=3d24af4c&"
import script from "./SubStatusIcon.vue?vue&type=script&lang=js&"
export * from "./SubStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./SubStatusIcon.vue?vue&type=style&index=0&id=3d24af4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports